<template>
  <div ref="container" :class="`app${isMagic ? ' is-magic' : ''}`">
    <template v-if="displayApp">
      <template v-if="displayWarning">
        <!-- UUID invalid or account not in order-->
        <span class="app-message">User not allowed</span>
      </template>
      <div class="global-loader" v-else-if="globalLoader">
        <!-- Loader -->
        <loader />
      </div>
      <template v-else>
        <!-- <template v-if="!success || isMagic"> -->
          <template v-if="!isMagic && !success">
            <h3 v-html="$t('contact.title')" class="app-title"/>

            <!-- Search -->
            <template>
              <h3 class="app-search-title">{{ $t('contact.search.title') }}</h3>
              <span class="app-search-subtitle">
                {{ $t('contact.search.subtitle') }}
                <button
                  v-show="displayCopylink"
                  @click="sendMessage"
                  class="app-search-subtitle-link">
                  <svg x="0px" y="0px" viewBox="0 0 1000 1000">
                    <path d="M387.1,925.4c-86.1,86.1-226.3,86.1-312.5-0.1c-86.1-86.1-86.1-226.3,0-312.4l221.3-221.3c86.1-86.1,226.3-86.1,312.5,0.1c2.3,2.3,4.6,4.7,6.8,7.1c1.3,1.1,2.5,2.2,3.8,3.4c3.5,3.5,6.4,7.3,8.7,11.4c0.3,0.4,0.6,0.7,0.9,1.1c-0.1,0.1-0.1,0.1-0.2,0.1c10.6,20,7.5,45.4-9.4,62.2c-17,17-42.6,20-62.6,9.1c-1.4,1.5-15.3-12.3-22.6-19.7l-0.1-0.1c-45-45-117.6-45.3-162.6-0.4L149.4,687.7c-45,45-45,117.9,0,162.9l0.1,0.1c45,45,117.9,45,162.9,0l133.5-133.5c46.3,22.7,100.8,23.5,147.5,2L387.1,925.4L387.1,925.4L387.1,925.4z M925.4,387.1L704.1,608.4c-86.1,86.1-226.3,86.1-312.5-0.1c-2.3-2.3-4.6-4.7-6.8-7.1c-1.3-1.1-2.5-2.2-3.7-3.4c-3.5-3.5-6.4-7.3-8.7-11.4c-0.3-0.4-0.6-0.7-0.8-1.1c0,0,0.1-0.1,0.2-0.1c-10.6-20-7.5-45.4,9.4-62.2c17-17,42.6-20,62.6-9.1c1.4-1.5,15.3,12.4,22.6,19.7l0.1,0.1c45,45,117.6,45.4,162.5,0.4l221.7-221.7c45-45,45-117.9,0-162.9l0-0.1c-45-45-117.9-45-162.9,0L554.2,282.8c-46.2-22.6-100.8-23.5-147.5-2L612.9,74.6c86.1-86.1,226.3-86.1,312.5,0.1C1011.5,160.8,1011.5,301,925.4,387.1L925.4,387.1L925.4,387.1z"/>
                  </svg>
                </button>
              </span>
              <search 
                @resultClick="caseClick"
                @toggleModify="onModify"
                :disabled="!displaySearch"
              />
            </template>
          </template>

          <div v-if="isMagic" :class="`app-magic${closeButton ? ' has-close' : ''}`">
            <div class="app-magic-container">
              <p class="app-magic-text" v-html="$t('contact.isMagic.title', { name: lawyer ? lawyer.name : '' })"/>
              <h1 class="app-magic-title">{{ $store.state.search.terms }}</h1>
              <button v-if="closeButton" class="app-magic-close" @click="onClose">
                <span class="u-visually-hidden">{{ $t('form.close') }}</span>
              </button>
            </div>
          </div>

          <!-- Form -->
          <form
            v-if="displayForm && !success"
            v-on:submit.prevent="onSubmit"
            class="app-form"
            novalidate
            ref="form"
          >
            <!-- Question -->
            <question
              v-for="(question, index) in questions"
              :key="question.id"
              :question="question"
              :index="index"
            />

            <div class="app-form-footer">
              <!-- Privacy -->
              <question :question="privacy[0]" />
              <question :question="terms[0]" />

              <p v-if="filesSize > 10" class="app-form-footer-error">{{ $t('form.errors.fileSize') }}</p>

              <!-- Trust message -->
              <div class="app-form-trust">
                <span class="svg">
                  <svg :width="18" :height="18" viewBox="0 0 229.5 229.5">
                    <path d="M214.419,32.12c-0.412-2.959-2.541-5.393-5.419-6.193L116.76,0.275c-1.315-0.366-2.704-0.366-4.02,0L20.5,25.927 c-2.878,0.8-5.007,3.233-5.419,6.193c-0.535,3.847-12.74,94.743,18.565,139.961c31.268,45.164,77.395,56.738,79.343,57.209 c0.579,0.14,1.169,0.209,1.761,0.209s1.182-0.07,1.761-0.209c1.949-0.471,48.076-12.045,79.343-57.209 C227.159,126.864,214.954,35.968,214.419,32.12z M174.233,85.186l-62.917,62.917c-1.464,1.464-3.384,2.197-5.303,2.197 s-3.839-0.732-5.303-2.197l-38.901-38.901c-1.407-1.406-2.197-3.314-2.197-5.303s0.791-3.897,2.197-5.303l7.724-7.724 c2.929-2.928,7.678-2.929,10.606,0l25.874,25.874l49.89-49.891c1.406-1.407,3.314-2.197,5.303-2.197s3.897,0.79,5.303,2.197 l7.724,7.724C177.162,77.508,177.162,82.257,174.233,85.186z" />
                  </svg>
                </span>
                <p v-html="trustMessage" />
              </div>

              <!-- Submit -->
              <button :disabled="sending || filesSize > 10" class="button button-cta" type="submit">
                <loader v-if="sending" />
                <template v-else>{{ $t('form.send') }}</template>
              </button>
            </div>

            <!-- Loader -->
            <!-- <loader v-if="sending" /> -->
          </form>

          <!-- Response -->
          <response v-if="response" :response="response" :message="message" />

          <div v-if="isMagic" class="app-footer">
            <a href="https://symplicy.com" target="_blank" class="app-footer-link">
              <p>Made with</p>
              <svg class="app-footer-logo" width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 10H38V32C38 39.732 31.732 46 24 46V46C16.268 46 10 39.732 10 32V10Z" stroke="#8F898F" stroke-width="2"/>
                <path d="M23.5744 37C22.283 37 21.1433 36.8676 20.1551 36.6029C19.167 36.3382 18.2131 35.9706 17.2935 35.5L17 30.5294H17.5283L19.6122 34.1471C20.1405 34.5784 20.7128 34.9118 21.3291 35.1471C21.9455 35.3824 22.5765 35.5 23.2222 35.5C24.2788 35.5 25.1398 35.25 25.805 34.75C26.4703 34.25 26.8029 33.5098 26.8029 32.5294C26.8029 31.8627 26.6513 31.3137 26.348 30.8824C26.0447 30.451 25.5409 30.0441 24.8365 29.6618L24.168 29.3136C23.8014 29.1294 23.3863 28.9298 22.9227 28.7149L21.9308 28.2647C20.5416 27.6569 19.4752 26.9314 18.7317 26.0882C17.9881 25.2451 17.6164 24.1961 17.6164 22.9412C17.6164 22.1569 17.8169 21.4069 18.218 20.6912C18.6191 19.9755 19.1572 19.3382 19.8323 18.7794C20.5073 18.2206 21.2607 17.7843 22.0922 17.4706C22.9238 17.1569 23.7799 17 24.6604 17C25.6583 17 26.617 17.1176 27.5367 17.3529C28.4563 17.5882 29.3075 17.9216 30.0901 18.3529L30.3836 23.0588H29.8847L27.8302 19.7353C27.3215 19.3431 26.8274 19.0441 26.348 18.8382C25.8686 18.6324 25.3256 18.5294 24.7191 18.5294C23.9168 18.5294 23.2516 18.7843 22.7233 19.2941C22.195 19.8039 21.9308 20.4804 21.9308 21.3235C21.9308 22.1275 22.2194 22.7892 22.7966 23.3088C23.3739 23.8284 24.3767 24.4118 25.805 25.0588C27.5856 25.8824 28.8966 26.7255 29.7379 27.5882C30.5793 28.451 31 29.5882 31 31C31 32.2549 30.638 33.3333 29.914 34.2353C29.1901 35.1373 28.2607 35.8235 27.1258 36.2941C25.9909 36.7647 24.8071 37 23.5744 37Z" fill="#8F898F"/>
                <path d="M14 4H34" stroke="#8F898F" stroke-width="2" stroke-linecap="square"/>
              </svg>
            </a>
          </div>

          <!-- Loader -->
            <loader v-if="loader" />
        <!-- </template> -->
      </template>
    </template>
    <template v-else>
      <span class="app-message">You do not have the permission to access this page</span>
    </template>
  </div>
</template>

<script>
// Modules
import Case from '@/components/modules/Case';
import Search from '@/components/modules/Search';
import Response from '@/components/modules/Response';
import Question from '@/components/modules/Question';
// Components
import Loader from '@/components/components/Loader';
import { sendEvent } from '@/helpers/gtm';
// import { delay } from '@/helpers/delay';

export default {
  /* eslint-disable */
  components: {
    Case,
    Loader,
    Search,
    Question,
    Response
  },
  async beforeMount() {
    console.log('updated');
    // const date1 = new Date();
    const params = this.getParams(document.URL);

    // All params check \\
    // UUID
    if (!params || !params.uuid) {
      this.$store.commit('setDisplayApp', false);
      return;
    }

    // Language
    if (params && params.lang) {
      if (this.$store.state.locales.indexOf(params.lang) !== -1) {
        this.$i18n.locale = params.lang;
        this.$store.commit('setLang', params.lang);
        this.$store.commit('calls/updateCallLocale', params.lang);
      }
    }

    // Legal case
    if (params.lawCase) {
      this.isMagic = true;
      document.documentElement.classList.add('scroll-blocked');
      this.$store.commit('search/updateMode', 'form');
      this.$store.commit('form/updateRequests');
    }

    // Close button
    if (params.noClose) {
      this.closeButton = false;
    }

    // Style
    if (params.style) {
      const split = params.style.split(':');
      document.documentElement.style.setProperty(split[0], split[1]);
    }

    this.$store.commit('client/updateUUID', params.uuid);

    if (params.lawCase) {
      const response = await this.$store.dispatch('calls/getDataForMagic', {
        uuid: params.uuid,
        lawcaseId: params.lawCase
      });

      if (!this.$store.state.client.inOrder) return;

      this.$store.commit('lawyer/updateLawyer', response.data.lawyer);
      this.$store.dispatch('lawyer/applyCss');
      this.$store.commit('search/updateLawCase', response.data.lawcase);
      this.$store.commit('search/updateTerms', response.data.lawcase.content);
      // Form
      this.$store.commit('form/updateUUID', response.data.form.uuid);
      this.$store.commit('form/update', { prop: 'meta', value: response.data.form.content.meta });
      this.$store.dispatch('form/formatForm', response.data.form.content);
      
      // this.$store.dispatch('form/getForm', {
      //   caseID: params.lawCase,
      //   uuid: this.$store.state.client.uuid
      // });

      this.$store.commit('form/updateRequests', 'dec');
    } else {
      // Default
      await this.$store.dispatch('client/checkInOrder');
      if (!this.$store.state.client.inOrder) return;
      await this.$store.dispatch('lawyer/getLawyer', params.uuid);
    }
  },
  beforeDestroy() {
    this.beforeLeave();
  },
  computed: {
    displayApp() {
      return this.$store.state.displayApp;
    },
    displayWarning() {
      return !this.$store.state.client.inOrder;
    },
    displayForm() {
      return this.$store.state.search.mode === 'form' && this.$store.state.form.content;
    },
    displaySearch() {
      return this.$store.state.search.mode === 'search';
    },
    displayCopylink() {
      return this.$store.state.search.lawCase && this.$store.state.search.lawCase.id;
    },
    lawyer() {
      return this.$store.state.lawyer.item;
    },
    privacy() {
      return this.$store.state.form.content.data.filter(question => question.id === 'question-privacy');
    },
    terms() {
      return this.$store.state.form.content.data.filter(question => question.id === 'question-terms');
    },
    questions() {
      return this.$store.state.form.content.data.filter(question => question.id !== 'question-privacy' && question.id !== 'question-terms');
    },
    results() {
      return this.$store.state.search.results;
    },
    noResult() {
      return this.$store.state.search.noResult && this.$store.state.search.terms.length > 4;
    },
    loader() {
      const { requests } = this.$store.state.form;
      return requests > 0;
    },
    globalLoader() {
      const { requests } = this.$store.state.client;
      if (this.isMagic) return requests > 0 || this.loader;
      return requests > 0;
    },
    sending() {
      return this.$store.state.form.sending;
    },
    response() {
      return this.$store.state.form.response;
    },
    filesSize() {
      return this.$store.state.form.filesSize;
    },
    success() {
      const response = this.$store.state.form.response;

      if (response) {
        if (response.status >= 200 && response.status < 300) {
          return true;
        }
      }

      return false;
    },
    message() {
      const response = this.$store.state.form.response;

      if (response) {
        if (response.status >= 200 && response.status < 300) {
          if (this.isMagic) return this.$t('form.messages.success-magic', { name: this.lawyer.name });
          else return this.$t('form.messages.success');
        }

        return this.$t('form.messages.error', { email: this.$store.state.lawyer.item.email });
      }

      return '';
    },
    trustMessage() {
      if(this.$store.state.lawyer.item?.is_baj) return this.$t('form.trust-message-baj');
      return this.$t('form.trust-message');
    }
  },
  data() {
    return {
      isMagic: false,
      closeButton: true,
      hasGTM: false
    }
  },
  methods: {
    // Search
    caseClick({ e, lawCase }) {
      this.$store.commit('search/updateLawCase', lawCase);
      sendEvent('symplicy:lawcase_choose', { lawcase: lawCase.content });

      this.$store.dispatch('form/getForm', {
        caseID: lawCase.id,
        uuid: this.$store.state.client.uuid
      });
      this.$store.commit('search/updateMode', 'form');

      if (this.$refs.container.parentElement) {
        this.$refs.container.parentElement.scrollTo(0, 0);
      }
    },
    onModify() {
      this.$store.commit('search/updateTerms', '');
      this.$store.commit('search/updateResults', []);
      this.$store.commit('search/updateMode', 'search');
    },
    onClose() {
      parent.postMessage(`close`, '*');
    },
    sendMessage() {
      parent.postMessage(`copy-link/${this.$store.state.search.lawCase.id}`, '*');
    },
    beforeLeave() {
      if (this.$store.state.form.uuid && this.$store.state.form.content) {
        const form = {
          uuid: this.$store.state.form.uuid,
          data: {}
        };

        this.$store.state.form.content.data.map((question) => {
          form.data[question.id] = question.value;
        });

        localStorage.setItem('saved-form', JSON.stringify(form));
      }
    },
    // Form
    async onSubmit(e) {
      this.$store.commit('form/updateSending', true);
      // Clean errors
      this.clean();

      // Validate questions
      const indexError = this.validate();

      // Throw errors
      if (indexError || indexError === 0) {
        this.index = indexError;

        setTimeout(() => {
          this.scrollToError();
          this.$store.commit('form/updateSending', false);
        }, 50);
        return;
      }

      // Get the data to send
      const data = await this.getFormData();

      // Send data
      this.$store.dispatch('form/send', data);
    },
    clean() {
      this.$store.state.form.content.data.map((question, index) => {
        this.$store.commit('form/updateError', { index, error: null });
      });
    },
    validate() {
      // let hasError = false;
      let indexError = null;

      this.$store.state.form.content.data.map((question, index) => {
        // Check question visibility
        if (!question.hasOwnProperty('isVisible') || question.isVisible) {
          // Check emptyness
          if (!question.value || question.value.length === 0) {
            if (!question.optional) {
              this.$store.commit('form/updateError', { index, error: question?.type === 'file' ? 'required-file' : 'required' });

              if (indexError === null || indexError > index) {
                indexError = index;
              }
            }
          } else {
            // eslint-disable-next-line
            if (question.type === 'email') {
              // eslint-disable-next-line
              const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

              if (!regex.test(question.value)) {
                this.$store.commit('form/updateError', { index, error: 'email' });

                if (indexError === null || indexError > index) {
                  indexError = index;
                }
              }
            }
          }
        }
      });

      return indexError;
    },
    async getFormData() {
      const answers = [];
      const questions = this.questions.filter(question => (!question.hasOwnProperty('isVisible') || question.isVisible || question.id === 'question-lawyer'));

      for (let i = 0; i < questions.length; i++) {
        const question = questions[i];

        let value = null;
        let type = null;

        if (question.type === 'file') {
          type = question.value.length > 1 ? 'files' : 'file';

          if (type === 'files') {
            value = await this.$store.dispatch('form/sendFiles', question.value);
          } else {
            value = await this.$store.dispatch('form/sendFile', question.value[0]);
          }
          // value = await this.$store.dispatch('form/sendFiles', question.value);
        }

        answers.push({
          order: i,
          id: question.id,
          type: type || question.type,
          value: value || question.value
        });
      }

      const data = {
        uuid: this.$store.state.form.uuid,
        lang: this.$store.state.locale,
        case_slug: this.$store.state.search.lawCase.slug,
        client_uuid: this.$store.state.client.uuid,
        mail_list: false,
        questions: answers
      };

      return data;
    },
    scrollToError() {
      const width = window.innerWidth;
      const $container = this.isMagic && width >= 600 ? this.$refs.form : this.$refs.container;
      const $el = $container.querySelectorAll('.question.has-error')[0];

      if (!$el) return;

      const offsets = {
        container: $container.offsetTop,
        el: $el.offsetTop
      };

      const scrollTo = offsets.el - offsets.container;
      
      if (this.isMagic) $container.scrollTo({ top: scrollTo, left: 0, behaviour: 'smooth' });
      else window.scrollTo({ top: scrollTo, left: 0, behaviour: 'smooth' });
    },
    // Utils
    getParams(url) {
      const match = url.match(/\?([\w_\-.=&%]+)/);

      if (!match) return null;

      const search = match[1].split('&');
      const object = {};

      for (let i = 0; i < search.length; i++) {
        const part = search[i].split('=');
        const { 0: key, 1: value } = part;
        object[key] = decodeURIComponent(value);
      }

      return object;
    },
  }
}
</script>


<style lang="scss">
  @import '@/scss/app.scss';

  .app {
    // @include margin(null null 60px);
    @include padding(var(--symplicy-spacing-v) var(--symplicy-spacing-h));
    width: 100%;
    overflow: hidden;

    @include mq($until: 'm') {
      @include padding(null 16px);
      @include margin(null null 32px);
    }

    &.is-magic {
      @include padding(0);
      position: relative;
      height: 100%;
      display: flex;
      flex-direction: column;

      @include mq($until: 'm') {
        // @include margin(16px null);
        // height: calc(100% - 32px);
        height: 100%;
        background-color: color('background');
        // border-radius: 10px;
        overflow: auto;
      }

      .global-loader {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }

      .app-magic {
        @include padding(80px null 32px);
        padding-top: 80px;
        color: color('text');

        // @include mq($from: 'm') {
          // color: #fff;
        // }

        @include mq($until: 'm') {
          @include padding(24px 16px 16px);
          position: sticky;
          top: 0;
          border-bottom: 1px solid #e6e1e6;
          z-index: 1;
          background-color: color('background');
        }

        &.has-close {
          .app-magic-text {
            padding-right: 42px;
          }
        }

        &-container {
          position: relative;
        }

        &-text {
          font-family: var(--symplicy-font-secondary);
          font-size: rem(14px);
          line-height: (24/14);

          strong {
            font-weight: 700;
          }

          @include mq($until: 'm') {
            font-size: rem(12px);
            line-height: (16/12);
          }
        }

        &-title {
          font-family: var(--symplicy-font-primary);
          font-size: rem(24px);
          font-weight: 700;
          line-height: (32/24);

          @include mq($until: 'm') {
            font-size: rem(16px);
          }
        }

        &-close {
          position: absolute;
          top:-8px;
          right:-5px;
          height:30px;
          width:30px;
          margin:0;
          padding:0;
          z-index:2;
          border:0;
          border-radius:0;
          background:none;
          -webkit-appearance:none;
          -moz-appearance:none;
          appearance:none;
          outline:none;
          cursor:pointer;
          transition:opacity .3s cubic-bezier(.165,.84,.44,1);

          @include mq($from: 'm') {
            // opacity: .5;
            &::before,
            &::after {
              background: #8F898F;
            }

            &:hover, 
            &:focus {
              &::before,
              &::after {
                background:rgba(0, 0, 0, 1);
              }
              // opacity: 1;
            }
          }

          &::after,
          &::before {
            position:absolute;
            top:calc(50% - 1px);
            left:calc(50% - 10px);
            height:2px;
            width:20px;
            content:"";
            -webkit-transform-origin:50% 50%;
            transform-origin:50% 50%;
            transition: background .3S $ease-out-quart;
            // background:rgba(0, 0, 0, 1);
            // background:rgba(var(--symplicy-color-text-light), 1);

            @include mq($until: 'm') {
              background: color('text-light');
            }
          }

          &:before{
            -webkit-transform:rotate(45deg);
            transform:rotate(45deg)
          }

          &:after{
            -webkit-transform:rotate(-45deg);
            transform:rotate(-45deg)
          }
        }
      }

      .app-form {
        @include padding(var(--symplicy-spacing-v) var(--symplicy-spacing-h));
        @include position(relative, 0 null null 0);
        background-color: rgba(var(--symplicy-color-background), 1);
        border-radius: 10px;
        margin-top: 0;
        // 168px = header
        // 104px = footer
        // height: calc(100% - 272px);
        overflow: auto;
        flex-grow: 1;

        @include mq($until: 'm') {
          @include padding(16px 16px 12px);
          overflow: visible;
        }

        &-footer {
          margin-bottom: 0;
        }
      }
    }


    &-message {
      @include margin(16px auto);
      display: block;
      color: color('text');
      font-size: rem(20px);
      font-weight: 600;
      line-height: 1.2;
      text-align: center;
    }

    &-title {
      color: color('text-light');
      font-family: var(--symplicy-font-secondary);
      font-size: rem(12px);
      line-height: (16 / 12);
    }

    &-search {
      &-title {
        @include margin(24px null null);
        color: color('text');
        font-size: rem(16px);
        line-height: (24 / 16);
      }

      &-subtitle {
        @include margin(null null 8px);
        display: flex;
        justify-content: space-between;
        color: color('text-light');
        font-family: var(--symplicy-font-secondary);
        font-size: rem(12px);
        line-height: (16 / 12);

        &-link {
          @include size(16px);
          cursor: pointer;
          outline: none;

          &:hover {
            svg {
              fill: color('highlight');
            }
          }

          svg {
            @include size(100%);
            display: block;
            transition: fill .3s $ease-out-quart;
            fill: color('text-light', .5);
          }
        }
      }
    }

    &-form {
      @include margin(var(--symplicy-spacing-v) null null);
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .question {
        // @include padding(null null var(--symplicy-spacing-v));
        width: 100%;

        &.question-firstname,
        &.question-lastname,
        &.question-email,
        &.question-phone {
          @include mq($from: 'm') {
            width: calc(50% - var(--symplicy-spacing-h));
          }
        }

        + .question:not(.question-terms) {
          @include margin(var(--symplicy-spacing-v) null null);
        }
      }

      &-footer {
        @include padding(var(--symplicy-spacing-v) null null);
        @include margin(calc(var(--symplicy-spacing-v) * 2) null 32px);
        // @include margin(calc(var(--symplicy-spacing-v) - 8px) null 32px);
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
        border-top: 1px solid color('border');

        .question {
          width: 100%;
          margin-bottom: calc(var(--symplicy-spacing-v) * 1.5);
          // padding-bottom: calc(var(--symplicy-spacing-v) * 1.5);
        }

        &-error {
          @include margin(null null 16px);
          width: 100%;
          color: color('error');
          font-size: rem(18px);
          font-weight: 600;
          line-height: 1.2;
          text-align: center;
        }

        .button {
          @include mq($until: 'm') {
            width: 100%;
          }

          @include mq($from: 'm') {
            margin-left: auto;
          }
        }
      }

      &-trust {
        display: flex;
        align-items: center;
        flex-grow: 1;
        position: relative;
        max-width: calc(100% - 130px);

        @include mq($until: 'm') {
          @include margin(12px null null);
          align-items: flex-start;
          order: 3;
          width: 100%;
          max-width: 100%;

          br {
            display: none;
          }
        }

        .svg {
          @include margin(null 8px null null);
          fill: color('text-light', .5);
        }

        p {
          color: color('text-light');
          font-family: var(--symplicy-font-secondary);
          font-size: rem(12px);
        }
      }

      .button-cta {
        .loader {
          margin-top: 12px;
          margin-bottom: 12px;

          .loader-dot {
            background-color: #fff;

            &::after {
              background-color: #fff;
            }
          }
        }
      }
    }

    // Footer (only in magic mode)
    &-footer {
      @include padding(16px null 32px);
      display: flex;
      flex-direction: column;
      align-items: center;

      @include mq($until: 'm') {
        @include padding(0 null 12px);
      }

      &-link {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-decoration: none;
        // opacity: .7;
        transition: opacity .3s $ease-out-quart;

        @include mq($until: 'm') {
          flex-direction: row;
        }

        // &:hover {
        //   opacity: 1;
        // }
      }

      p {
        color: #8F898F;
        font-family: var(--symplicy-font-secondary);
        font-size: rem(11px);
        font-weight: 700;
        line-height: (24 / 11);

        // @include mq($until: 'm') {
        //   color: color('text-light');
        // }
      }

      svg {
        @include mq($until: 'm') {
          margin-left: 4px;
          width: 22px !important;
          height: 22px !important;

          [stroke] {
            stroke: #8F898F;
            // stroke: color('text-light');
          }

          [fill] {
            fill: #8F898F;
            // fill: color('text-light');
          }
        }
      }
    }

    // Search
    // -----------------------------------------------------------------------------
    &-search-results {
      @include margin(20px null null);

      .case {
        &:first-child {
          border-radius: var(--symplicy-border-radius) var(--symplicy-border-radius) 0 0;
        }

        &:last-child {
          border-radius: 0 0 var(--symplicy-border-radius) var(--symplicy-border-radius);
        }
      }
    }

    // Loader
    // -----------------------------------------------------------------------------
    .loader {
      @include margin(20px null null);
    }
  }
</style>
